import { Box, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { BackstageTheme } from '@mainstage/theme';
import yaml from 'yaml';
import { CodeSnippet } from '../CodeSnippet';
import { CopyButton } from '../CopyButton';
import { CustomViewRegister } from '../CustomView/registry';
import { WbFieldLabel } from '../WbFieldLabel';
import { CustomViewGridElement } from './utility';

export function serializeValue(value: any, language: string): string {
  if (typeof value === 'string') return value;
  if (language === 'yaml') return yaml.stringify(value, null, 2);
  if (language === 'json') return JSON.stringify(value, null, 2);
  return String(value);
}

export function CodeBlockComponent(props: Record<string, any>) {
  const theme = useTheme<BackstageTheme>();
  const language: string = props.language ?? 'plaintext';
  const label: string | undefined = props.label;
  const showLineNumbers: boolean = props.showLineNumbers ?? false;
  const colSpan: number = props.colSpan ?? 4;
  const maxHeight: string = props.maxHeight ?? '400px';
  const hideCopyButton: boolean = props.hideCopyButton ?? false;

  // Empty-state resolution
  let value = props.value;
  const isEmpty = value === undefined || value === null || value === '';
  if (
    isEmpty &&
    props.default !== null &&
    props.default !== undefined &&
    props.default !== ''
  ) {
    value = props.default;
  } else if (isEmpty) {
    return (
      <CustomViewGridElement colSpan={colSpan}>
        {label && <WbFieldLabel label={label} style={{}} />}
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ fontStyle: 'italic' }}
        >
          No content available
        </Typography>
      </CustomViewGridElement>
    );
  }

  const text = serializeValue(value, language);

  return (
    <CustomViewGridElement colSpan={colSpan}>
      {label && <WbFieldLabel label={label} style={{}} />}
      <Box
        style={{
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: 4,
          overflow: 'hidden',
        }}
      >
        {!hideCopyButton && (
          <Box
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              borderBottom: `1px solid ${theme.palette.divider}`,
              backgroundColor: theme.palette.background.default,
              padding: '2px 4px',
            }}
          >
            <CopyButton text={text} size="small" style={{ minWidth: 'auto' }}>
              Copy
            </CopyButton>
          </Box>
        )}
        <CodeSnippet
          text={text}
          language={language}
          showLineNumbers={showLineNumbers}
          style={{ maxHeight, overflow: 'auto' }}
        />
      </Box>
    </CustomViewGridElement>
  );
}

CustomViewRegister.register({
  id: 'code_block',
  function: CodeBlockComponent,
});
